import React from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { FaSearch, FaTrashAlt } from 'react-icons/fa';

const LogFilters = ({ filters, setFilters, onFilter, onClearOldLogs }) => {
    return (
        <Card className="shadow-sm border-0 mb-4">
            <Card.Body>
                <Form onSubmit={(e) => { e.preventDefault(); onFilter(); }}>
                    <Row className="g-3 align-items-end">
                        <Col md={5}>
                            <Form.Group>
                                <Form.Label className="small fw-bold">Search Path / Keyword</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. /api/payment"
                                    value={filters.url}
                                    onChange={(e) => setFilters({ ...filters, url: e.target.value })}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label className="small fw-bold">Method</Form.Label>
                                <Form.Select
                                    value={filters.method}
                                    onChange={(e) => setFilters({ ...filters, method: e.target.value })}
                                >
                                    <option value="">All Methods</option>
                                    <option value="GET">GET</option>
                                    <option value="POST">POST</option>
                                    <option value="PUT">PUT</option>
                                    <option value="DELETE">DELETE</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label className="small fw-bold">Status Code</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="e.g. 500"
                                    value={filters.status}
                                    onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <div className="d-flex gap-2">
                                <Button variant="primary" type="submit" className="w-100">
                                    <FaSearch className="me-2" /> Filter
                                </Button>
                                <Button variant="outline-danger" onClick={onClearOldLogs} title="Clear 30+ days logs">
                                    <FaTrashAlt />
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default LogFilters;
